import { Card, CardFooter, CardHeader, CardPreview, Divider, Image, Link, Table, TableBody, TableCell, TableRow, Title3, Tooltip, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import { useContext, useEffect, useState } from "react";
import { Archive } from "../library/CosmeWidgetAPIClient";
import PageLoading from "./PageLoading";
import logo from '../cosme-widget-logo.png';
import { CWClientContext } from "../App";

const useStyles = makeStyles({
    card: {
        height: "440px",
        width: "684px",
        ...shorthands.margin("auto"),
        boxShadow: tokens.shadow8,
        ...shorthands.borderRadius("12px"),
        ...shorthands.borderColor(tokens.colorPaletteMinkBorderActive),
    },
    header: {
        height: "50px",
    },
    preview: {
        minHeight: "280px",
    },
    tooltipImage: {
        height: "200px",
    },
    ogpImage: {
        height: "40px",
    },
    Logo: {
        height: "4vh",
        marginTop: "9px",
        marginBottom: "-9px",
    },
    table: {
        ...shorthands.margin("auto"),
        maxWidth: "92%",
    }

});


type WidgetProp = {
    title: string | undefined,
    maker: string | undefined,
    brand: string | undefined,
    item: string | undefined,

}

const Widget = (prop: WidgetProp) => {
    const styles = useStyles();
    const [archives, setArchives] = useState<Archive[]>([]);
    const cwClient = useContext(CWClientContext);

    useEffect(() => {
        if (prop.maker !== undefined && prop.brand !== undefined) {
            (async () => {
                cwClient.searchArchives({
                    limit: 5,
                    status: "DONE",
                    offset: 0,
                    media: undefined,
                }).then((archives) => {
                    setArchives(archives);
                });
            })();

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prop.maker, prop.brand]);

    const cardPreviewArea = () => {
        if (archives === undefined) {
            return (<PageLoading
                message="記事を検索中です。"
            />);
        } else {
            return (
                <CardPreview>
                    <Table className={styles.table}>
                        <TableBody>

                            {archives.map((archive) => {
                                return (
                                    <>
                                        <Tooltip
                                            content={
                                                <Image className={styles.tooltipImage} src={archive.ogp.image} />
                                            }
                                            relationship="label"
                                        >
                                            <TableRow>
                                                <TableCell>
                                                    <Image className={styles.ogpImage} src={archive.ogp.image} />
                                                </TableCell>
                                                <TableCell>
                                                    <Link href={archive.ogp.url}
                                                        target="_blank">
                                                        {archive.pageTitle}
                                                    </Link>
                                                </TableCell>

                                            </TableRow>
                                        </Tooltip>
                                    </>
                                );
                            })}
                        </TableBody>
                    </Table>
                </CardPreview>
            );
        }
    }

    return (
        <Card className={styles.card}>
            <CardHeader
                className={styles.header}
                image={
                    <Image src={logo} className={styles.Logo} />
                }
                header={
                    <Title3>{prop.title}</Title3>
                }
            >
            </CardHeader>
            <Divider />
            {cardPreviewArea()}
            <CardFooter
                content="Widgetのサンプルです。"
            >
                {prop.maker + "/" + prop.brand + "/" + prop.item + "の記事"} - Widgetのサンプルです。
            </CardFooter>
        </Card >
    );
}
export default Widget;